// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaticBannersService-row {
    display: grid;
    gap: 16px;
    align-items: center;
    justify-content: center;
    width: 100%;
    grid-template-columns: 33.333% 33.333% 33.333%;
}

.StaticBannersService-row.full {
    grid-template-columns: 1fr;
}

.StaticBannersService-row.half {
    grid-template-columns: 50% 50%;
}

.StaticBannersService-figure {
    height: 206px;
    overflow: hidden;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.StaticBannersService-figure img {
    height: 206px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServicesBannersForHome/components/StaticBannersService/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".StaticBannersService-row {\n    display: grid;\n    gap: 16px;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    grid-template-columns: 33.333% 33.333% 33.333%;\n}\n\n.StaticBannersService-row.full {\n    grid-template-columns: 1fr;\n}\n\n.StaticBannersService-row.half {\n    grid-template-columns: 50% 50%;\n}\n\n.StaticBannersService-figure {\n    height: 206px;\n    overflow: hidden;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.StaticBannersService-figure img {\n    height: 206px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
